const unkwnown = require('./unknown');

module.exports = {
  ...unkwnown,
  desktop: 'desktop',
  mobile: 'mobile',
  tablet: 'tablet',
};
